import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import Api from '../../api/api';

export type SignupEventDto = {
  eventId: string;
  groupIdToJoin?: string;
};

export const signupEvent = async ({ eventId, groupIdToJoin }: SignupEventDto): Promise<void> => {
  const [response, bodyOrError] = await Api.post(`events/${eventId}/sign-up`, { groupIdToJoin });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useSignupEvent = (options?: Omit<UseMutationOptions<void, Error, SignupEventDto, unknown>, 'mutationFn' | 'mutationKey'>) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationKey: ['signupEvent'],
    mutationFn: signupEvent,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['getEventById', variables.eventId]);
    },
  });
};
